module.exports = __webpack_public_path__ + "img/icon_bell.7194a4e2.svg";